import React from 'react';
import {
  Grid,
  Box,
  Typography,
  Button,
  Alert,
  Card,
  CardContent,
  IconButton,
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import TreatmentForm from '../TreatmentForm';

const TreatmentsSection = ({
  treatments,
  errors,
  isActive,
  templateVersions,
  onAddTreatment,
  onRemoveTreatment,
  onTreatmentChange,
  getSafeTemplateVersion,
}) => {
  return (
    <>
      <Grid size={{ xs: 12 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Treatments</Typography>
          <Button
            startIcon={<AddIcon />}
            onClick={onAddTreatment}
            size="small"
            disabled={isActive}
          >
            Add Treatment
          </Button>
        </Box>
        {errors.treatments && (
          <Alert severity="error" sx={{ mt: 1 }}>
            {errors.treatments}
          </Alert>
        )}
        {isActive && (
          <Alert severity="warning" sx={{ mt: 1 }}>
            Cannot modify treatments while experiment is active. Please stop the
            experiment first.
          </Alert>
        )}
      </Grid>

      {treatments.map((treatment, index) => (
        <Grid
          size={{ xs: 12 }}
          key={treatment.treatment_id || `treatment-${index}`}
        >
          <Card variant="outlined">
            <CardContent>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
              >
                <Typography variant="subtitle2">
                  Treatment {index + 1}
                </Typography>
                {treatments.length > 1 && (
                  <IconButton
                    size="small"
                    onClick={() => onRemoveTreatment(index)}
                    color="error"
                    disabled={isActive}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </Box>

              <TreatmentForm
                treatment={treatment}
                index={index}
                templateVersions={templateVersions}
                errors={errors}
                isActive={isActive}
                onTreatmentChange={onTreatmentChange}
                getSafeTemplateVersion={getSafeTemplateVersion}
              />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </>
  );
};

export default TreatmentsSection;
